export default "__VITE_ASSET__BdmFo$my__"